module.exports = __webpack_public_path__ + "static/media/icono-pantalla-completa.d69ac76a.png";